module.exports = __webpack_public_path__ + "img/TechGatherGold2_ua.73532f48.webp";